import {
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";

import FixedBar from "components/ui/FixedBar";
import SubmitButton from "components/ui/SubmitButton";
import { useSuccessDialogContext } from "components/ui/SuccessDialog/SuccessDialogContext";
import { useMessages } from "hooks/useMessages";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Inputs, useSaveTag } from "../hooks/useSaveTag";

const TAG_COLOR_SCHEMES = {
  orange: "Laranja",
  pink: "Rosa",
  blue: "Azul",
  purple: "Roxo",
  green: "Verde",
  red: "Vermelho",
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  colorScheme: Yup.string().required(),
});

type FormProps = {
  tag?: any;
  type: string;
};

export default function TagForm({ tag, type }: FormProps) {
  const defaultValues: Inputs = {
    name: tag?.name,
    colorScheme: tag?.colorScheme,
    active: tag?.active,
  };

  const navigate = useNavigate();
  const { openSuccessDialog } = useSuccessDialogContext();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isValid },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(validationSchema) as Resolver<Inputs>,
    defaultValues,
  });

  const { onError } = useMessages();

  const isActive = watch("active");

  const { onSaveTag, isPending } = useSaveTag({
    tagId: tag?.id,
    onSuccess: () => {
      reset();
      navigate(`/tags/${type}`);
      if (!tag?.id) {
        openSuccessDialog({
          title: "Nova tag cadastrada!",
          description: "",
          actionButtonText: "Criar mais uma tag",
          actionButton: `/tags/${type}/novo`,
          closeButtonText: "Tudo certo",
        });
      }
    },
    onError: (error) => onError(error?.response?.data?.message),
  });

  const onSubmit: SubmitHandler<Inputs> = (data) =>
    onSaveTag({ ...data, type });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={!!errors.name} isRequired>
        <FormLabel>Nome</FormLabel>
        <Input {...register("name")} autoFocus />
      </FormControl>

      <FormControl isInvalid={!!errors.colorScheme} isRequired>
        <FormLabel>Cor</FormLabel>
        <Select {...register("colorScheme")} placeholder="Selecione uma cor">
          {Object.entries(TAG_COLOR_SCHEMES).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </Select>
      </FormControl>

      {tag && (
        <FormControl isInvalid={!!errors.active}>
          <FormLabel>Status</FormLabel>
          <Switch {...register("active")}>
            {isActive ? "Ativo" : "Inativo"}
          </Switch>
        </FormControl>
      )}

      <FixedBar>
        <SubmitButton isDisabled={isPending || !isValid} isLoading={isPending}>
          {!tag ? "Cadastrar" : "Atualizar"}
        </SubmitButton>
      </FixedBar>
    </form>
  );
}
